// import Backbone from 'backbone';
import tmpl from '../../templates';
import PriceBreakdownList from '../../collections/priceBreakdownList';
import User from '@modules/User';

var PriceBreakdownModuleView = Backbone.View.extend( {

    template: _.template( tmpl.priceBreakdownModule ),

    hasPriceRestrictions: false,

    initialize: function ( pricebreaks ) {
        this.collection = new PriceBreakdownList( pricebreaks || [] );
        this.listenTo( this.collection, 'change reset', this.render );
    },

    setPriceRestrictions: function ( hasRestrictions ) {
        this.hasPriceRestrictions = hasRestrictions;
    },

    getPriceBreaks: function () {
        return this.collection.models.slice( 1 );
    },

    render: function () {
        this.$el.html( this.template( {
            isLogged: User.isLogged(),
            hasPriceRestrictions: this.hasPriceRestrictions,
            priceBreakdown: this.getPriceBreaks()
        } ) );
        return this;
    },

    close: function () {
        this.$el.off();
        this.$el.remove();
    }
} );

export default PriceBreakdownModuleView;
